import cx from 'classnames';
import Loader from 'components/loader';
import WhiteBox from 'components/elems/whitebox';
import {
  SportsStrings, formatMetaById, PoolStateToStatus, Status,
} from 'utils/game';

import {
  StatusElem, Actions, BetResult,
} from 'components/bets/calendar/fields';

import styles from './list.module.css';

function predictions(lines, eventId) {
  return lines.map((l) => JSON.parse(l)[eventId] || 0);
}

const List = ({ loading, list = [] }) => {
  const firstLoading = list.length === 0 && loading;

  return (
    <ul className={styles.list}>
      {list.map(({
        bet, ticket, details,
        startTime, state, owner,
      }) => {
        const status = Status[PoolStateToStatus[state]];
        const ticketEvents = ticket?.events || [];
        const fixedEventIds = ticket?.fixedEventIds || [];
        const needToAdd = ticketEvents.filter((event) => {
          const scoresLines = predictions(bet.lines, event.id);
          return scoresLines.every((it) => it === 0) && !!event?.probability;
        }).length > 0;

        return (
          <WhiteBox
            elem="li"
            key={bet.id}
            className={cx(styles.item, styles[status.name], 'overflow-hidden w-full mb-4 p-3')}
          >
            <StatusElem status={status} startTime={startTime} />
            <span>{ `${SportsStrings.Football} / ${owner || 'System'}` }</span>
            <span>{ ticket.name }</span>
            <span>
              {`${formatMetaById(bet.format).multiplier || ''} - `}
              {`${(bet.amount / 100) || ''}`}
              &#x1F4B0;
            </span>
            <span className={styles.betResult}>
              Place:
              {' '}
              <BetResult status={status} score={details} />
            </span>
            <Actions
              isPoolPage
              needToAdd={needToAdd}
              ticketName={ticket.name}
              fixedEventIds={fixedEventIds}
              events={ticketEvents}
              isPrivate={Boolean(owner)}
              id={bet.id}
              status={state}
            />
          </WhiteBox>
        );
      })}
      <WhiteBox elem="li" className={cx(styles.last, 'overflow-hidden w-full mb-4 p-3')}>
        {
          firstLoading && <Loader className={styles.loader} />
        }
        {
          list.length === 0 && <div className="text-center py-2 text-lg">No pools yet</div>
        }
      </WhiteBox>
    </ul>
  );
};

export default List;
